import LTR from "@brand-icons/ploom/device-default/device-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const DeviceDefaultIcon = iconFactory("DeviceDefaultIcon", LTR);
